export type StepInfo = {
	id: number
	name: string
	isCompleted: boolean
	completedAt: Date
	dueDate: Date
}

export type GoalInfo = {
	id: number
	name: string
	isCompleted: boolean
	completedAt: Date
	dueDate: Date
	steps?: StepInfo[]
}

export type IndividualPlanInfo = {
	id: number
	name: string
	isClosed: boolean
	closedAt: Date
	dueDate: Date
	goals?: GoalInfo[]
}

export type ProgramEnrollmentInfo = {
	id: number
	programId: number
	programName: string
	isTerminated: boolean
	isArchived: boolean
	archivedAt: Date
	dueDate?: Date
	individualPlans?: IndividualPlanInfo[]
}

export class ClientIPList {
	static serviceName = 'features/client-ip/list'
	programEnrollment?: ProgramEnrollmentInfo[]
}
